import { render } from "./MessagesList.vue?vue&type=template&id=71550cac&scoped=true"
import script from "./MessagesList.vue?vue&type=script&lang=js"
export * from "./MessagesList.vue?vue&type=script&lang=js"

import "./MessagesList.vue?vue&type=style&index=0&id=71550cac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71550cac"],['__file',"modules/messages-list/ui/apos/components/MessagesList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71550cac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71550cac', __exports__)) {
    api.reload('71550cac', __exports__)
  }
  
  module.hot.accept("./MessagesList.vue?vue&type=template&id=71550cac&scoped=true", () => {
    api.rerender('71550cac', render)
  })

}


export default __exports__